import { QueryEmitterServicesProvider, QueryEmitter, ValueAdapterProvider, KeywordToResourceResolver, QueryExpressionParserService, QueryBuilderService, StrictSqlWhereParserService } from "@nrwl/query-emitter";
import { Injectable } from "@angular/core";

@Injectable()
export class PtcQueryEmitterServicesProvider extends QueryEmitterServicesProvider {

  constructor(
    private readonly queryEmitter: QueryEmitter,
    private readonly queryBuilder: QueryBuilderService,
    private readonly valueAdapter: ValueAdapterProvider,
    private readonly resolver: KeywordToResourceResolver,
    private readonly parser: QueryExpressionParserService,
    private readonly expParser: StrictSqlWhereParserService
  ) {
    super();
  }
  getDataSource(): QueryEmitter {
    return this.queryEmitter;
  }
  getBuilder(): QueryBuilderService {
    return this.queryBuilder;
  }
  getValueAdapter(): ValueAdapterProvider {
    return this.valueAdapter;
  }
  getResolver(): KeywordToResourceResolver {
    return this.resolver;
  }
  getParser(): QueryExpressionParserService {
    return this.parser;
  }
  getExpParser(): StrictSqlWhereParserService {
    return this.expParser;
  }
}
